import { FormField } from '@sunwebgroup/uds-ui/fields/form-field'
import { ToggleButton, ToggleButtonGroup } from '@sunwebgroup/uds-ui/toggle-button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import {
  golfEditingValueForSlotSelector,
  golfHolesForLocationSelector,
} from '@/scopes/checkout/components/services/GolfService/selectors'
import {
  getGolfSlotIdBeingEdited,
  useGolfServiceStore,
} from '@/scopes/checkout/components/services/GolfService/store'
import { updateEditingGolfSlotHoles } from '@/scopes/checkout/domain/actions'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import styles from './Filters.module.css'

export function HolesFilter() {
  const intl = useIntl()
  const { service, setServiceLocalValue } = useService(ServiceType.Golf)
  const slotId = useGolfServiceStore(getGolfSlotIdBeingEdited)

  const slot = golfEditingValueForSlotSelector(service, slotId ?? '')
  const availableHoles = golfHolesForLocationSelector(service, slot?.locationId ?? null)

  if (!slotId)
    return null

  return (
    <FormField label={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_holes_label' })}>
      <ToggleButtonGroup
        type="single"
        className={styles.filterToggleGroup}
        value={slot?.holes?.toString() ?? ''}
        onValueChange={(v: string | undefined) => v && setServiceLocalValue(
          updateEditingGolfSlotHoles({ slotId, holes: Number(v) }),
        )}
      >
        {availableHoles.map((h) => {
          return (
            <ToggleButton
              key={h}
              value={h.toString()}
            >
              <Typography>{h}</Typography>
            </ToggleButton>
          )
        })}
      </ToggleButtonGroup>
    </FormField>
  )
}
